@let isRMMPE = permissionsEnum.RmmPerEndpoint | can: 'read';
@let isRMMCE = permissionsEnum.RmmCeEnabled | can: 'read';
@let hasHelpMarketing = 'HelpMarketing' | can: 'read';

<mbs-modal [title]="'shared:computers.connectionLicense.licenseRequired' | i18next">
  <ng-container modal-body>
    <mbs-alert [type]="alertType.info">
      @if (!isWebRTC()) {
        {{ 'shared:computers.connectionLicense.connectOrRMMlicenseIsRequiredDesktop' | i18next }}
        <ul class="pb-2 pl-4 m-0">
          <li>{{ 'shared:computers.connectionLicense.connectOrRMMlicenseIsRequiredDesktopPoint1' | i18next }}</li>
          @if (!isRMMPE && isRMMCE && (limitRMMCEExceeded$ | async) === false) {
            <li>{{ 'shared:computers.connectionLicense.connectOrRMMlicenseIsRequiredDesktopPoint2' | i18next }}</li>
          }
        </ul>
      } @else {
        {{ 'shared:computers.connectionLicense.connectOrRMMlicenseIsRequiredWebRTC' | i18next }}
        <ul class="pb-2 pl-4 m-0">
          <li>{{ 'shared:computers.connectionLicense.connectOrRMMlicenseIsRequiredWebRTCPoint1' | i18next }}</li>
          <li>{{ 'shared:computers.connectionLicense.connectOrRMMlicenseIsRequiredWebRTCPoint2' | i18next }}</li>
          @if (!isRMMPE && isRMMCE && (limitRMMCEExceeded$ | async) === false) {
            <li>{{ 'shared:computers.connectionLicense.connectOrRMMlicenseIsRequiredWebRTCPoint3' | i18next }}</li>
          }
        </ul>
      }
      @if (hasHelpMarketing) {
        <a
          href="/AP/Help/remote-management/connect/licensing"
          target="_blank">
          {{ 'shared:computers.connectionLicense.learnMore' | i18next }}
        </a>
      }
    </mbs-alert>
    {{ 'shared:computers.connectionLicense.onceYouGrantRequiredLicense' | i18next }}
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="baseModal.save()">
      {{ 'shared:buttons.proceed' | i18next }}
    </mbs-button>
    <mbs-button (click)="baseModal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
